import IModel from "./IModel";
import User, { WorkTime } from "./User";

export default class FindLocation implements IModel<FindLocation> {
	id: number | null;
	name: string | null;
	active: string | null;
	userId: number | null;
	address?: string | null;
	displayAddress?: string | null;
	displayName?: string | null;
	type?: string;
	rateReview?: number | null;
	reviewCount?: string | null;
	lat?: number | null;
	long?: number | null;
	fee?: number | null;
	workTime?: WorkTime[] | null;
	createdAt?: Date | null;
	updatedAt?: Date | null;
	distance?: number | string;
	user?: User | null;
	insuranceFee?: number | null;
	timezoneId?: string;

	constructor(input?: Partial<FindLocation>) {
		this.id = input?.id || null;
		this.name = input?.name || null;
		this.active = input?.active || null;
		this.userId = input?.userId || null;
		this.address = input?.address || null;
		this.displayAddress = input?.displayAddress;
		this.displayName = input?.displayName;
		this.type = input?.type;
		this.rateReview = input?.rateReview || null;
		this.reviewCount = input?.reviewCount;
		this.lat = input?.lat;
		this.long = input?.long;
		this.fee = input?.fee;
		this.workTime = input?.workTime;

		this.createdAt = input?.createdAt;
		this.updatedAt = input?.updatedAt;
		this.distance = input?.distance;
		this.insuranceFee = input?.insuranceFee;
		this.timezoneId = input?.timezoneId;
	}

	parse(json: any): FindLocation {
		if (!json) return this;
		Object.assign(this, {
			...json,
		});

		// this.createUserName();

		return this;
	}

	clone(): FindLocation {
		return new FindLocation({
			...this,
		});
	}
}
